import AnatoliSmorin from './assets/cards/Anatoli Smorin.jpg';
import BobsonDugnutt from './assets/cards/Bobson Dugnutt.jpg';
import DarrylArchideld from './assets/cards/Darryl Archideld.jpg';
import DeanWesrey from './assets/cards/Dean Wesrey.jpg';
import DwigtRortugal from './assets/cards/Dwigt Rortugal.jpg';
import GlenallenMixon from './assets/cards/Glenallen Mixon.jpg';
import JeromyGride from './assets/cards/Jeromy Gride.jpg';
import KarlDandleton from './assets/cards/Karl Dandleton.jpg';
import KevinNogilny from './assets/cards/Kevin Nogilny.jpg';
import MarioMcRlwain from './assets/cards/Mario McRlwain.jpg';
import MikeSernandez from './assets/cards/Mike Sernandez.jpg';
import MikeTruk from './assets/cards/Mike Truk.jpg';
import OnsonSweemey from './assets/cards/Onson Sweemey.jpg';
import RaulChamgerlain from './assets/cards/Raul Chamgerlain.jpg';
import ReyMcSriff from './assets/cards/Rey McSriff.jpg';
import ScottDourque from './assets/cards/Scott Dourque.jpg';
import ShownFurcotte from './assets/cards/Shown Furcotte.jpg';
import SleveMcDichael from './assets/cards/Sleve McDichael.jpg';
import TimSandaele from './assets/cards/Tim Sandaele.jpg';
import ToddBonzalez from './assets/cards/Todd Bonzalez.jpg';
import TonySmehrik from './assets/cards/Tony Smehrik.jpg';
import WillieDustice from './assets/cards/Willie Dustice.jpg';

export const images = {
  'Anatoli Smorin': AnatoliSmorin,
  'Bobson Dugnutt': BobsonDugnutt,
  'Darryl Archideld': DarrylArchideld,
  'Dean Wesrey': DeanWesrey,
  'Dwigt Rortugal': DwigtRortugal,
  'Glenallen Mixon': GlenallenMixon,
  'Jeromy Gride': JeromyGride,
  'Karl Dandleton': KarlDandleton,
  'Kevin Nogilny': KevinNogilny,
  'Mario McRlwain': MarioMcRlwain,
  'Mike Sernandez': MikeSernandez,
  'Mike Truk': MikeTruk,
  'Onson Sweemey': OnsonSweemey,
  'Raul Chamgerlain': RaulChamgerlain,
  'Rey McSriff': ReyMcSriff,
  'Scott Dourque': ScottDourque,
  'Shown Furcotte': ShownFurcotte,
  'Sleve McDichael': SleveMcDichael,
  'Tim Sandaele': TimSandaele,
  'Todd Bonzalez': ToddBonzalez,
  'Tony Smehrik': TonySmehrik,
  'Willie Dustice': WillieDustice,
};
